"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDoctorSubstituteContractExistsResponseSchema = void 0;
const zod_1 = require("zod");
exports.getDoctorSubstituteContractExistsResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        intersect: zod_1.z.boolean(),
    }),
});
